var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 32 17.332031 C 33.472656 17.332031 34.667969 18.527344 34.667969 20 L 34.667969 36 C 34.667969 37.472656 33.472656 38.667969 32 38.667969 C 30.527344 38.667969 29.332031 37.472656 29.332031 36 L 29.332031 20 C 29.332031 18.527344 30.527344 17.332031 32 17.332031 Z M 32 17.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 32 49.332031 C 34.210938 49.332031 36 47.542969 36 45.332031 C 36 43.125 34.210938 41.332031 32 41.332031 C 29.789062 41.332031 28 43.125 28 45.332031 C 28 47.542969 29.789062 49.332031 32 49.332031 Z M 32 49.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 26.203125 5.945312 C 28.785156 1.574219 35.21875 1.574219 37.796875 5.945312 L 63.09375 48.804688 C 65.753906 53.316406 62.304688 58.667969 57.296875 58.667969 L 6.703125 58.667969 C 1.695312 58.667969 -1.753906 53.316406 0.90625 48.804688 Z M 33.203125 8.65625 C 32.6875 7.78125 31.3125 7.78125 30.796875 8.65625 L 5.5 51.515625 C 5.089844 52.210938 5.519531 53.332031 6.703125 53.332031 L 57.296875 53.332031 C 58.480469 53.332031 58.910156 52.210938 58.5 51.515625 Z M 33.203125 8.65625 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.541031ec56912adc5d9ee5258d965ffe.svg";
export { ForwardRef as ReactComponent };